import React, { Component } from 'react';
import LoadMask from 'Utils/LoadMask/LoadMask';
import classNames from 'classnames';
import Form from './WhearhouseForm';

export default class RolesCrear extends Component {

    state = {
        editar: false,
        mensaje: 'Agregar Bodega',
        password: false,
    }

    componentWillMount(){
        if(this.props.match.params.id){
            this.props.detail(this.props.match.params.id);
            this.setState({
                editar: true,
                mensaje: 'Editar Bodega'
            });
        }
    }

    render() {

        const {
            create,
            update,
            isNavBarOpen,
        } = this.props;

        const {
            updateData,
            cargando,
        } = this.props;

        return (
            <div className={classNames('content', { 'content-min': isNavBarOpen })}>
                <div className="m-auto row-fluid card-form">
                    <div className="table-decoration">
                        <LoadMask loading={cargando} blur_1>
                            {
                                this.state.editar ?
                                    <div>
                                        <div className="top-title">
                                            BODEGA
                                        </div>
                                        <Form
                                        onSubmit={update}
                                        updateData={updateData}
                                        editando={true} />
                                    </div>
                            :
                                <div>
                                    <div className="top-title">
                                        CREAR BODEGA
                                    </div>
                                    <Form onSubmit={create} />
                                </div>
                            }
                        </LoadMask>
                    </div>
                </div>
            </div>
        )
    }
}
